import http from "./httpService";
import config from "../config.json";

const apiEndpoint = config.apiEndpoint + "/teams";

export async function getTeams() {
  const response = await http.get(apiEndpoint);
  return response.data;
}

export async function getTeam(id) {
  const response = await http.get(apiEndpoint + "/" + id);
  return response.data;
}

export async function saveTeam(team) {
  let teamInDb = team || {};
  teamInDb.name = team.name;

  if (teamInDb.id === -1) await http.post(apiEndpoint, teamInDb);
  else await http.put(apiEndpoint + "/" + teamInDb.id, teamInDb);

  return teamInDb;
}

export async function deleteTeam(id) {
  await http.delete(apiEndpoint + "/" + id);
}



// WEBPACK FOOTER //
// ./src/services/teamService.js